<div class="wrapper">
    <div class="header" *ngIf="!isMobile">
        <div class="header__buttons">
            <h2 class="header__title">Лаборатория</h2>
            <button
                class="header__buttons-button"
                (click)="btnFiltrTek()"
                [class.selected]="selectedButton === 'today'"
                [disabled]="loadingOrderList || selectedButton === 'today'"
            >
                за сегодня
            </button>
            <button
                class="header__buttons-button"
                (click)="btnFiltr3Day()"
                [class.selected]="selectedButton === '3days'"
                [disabled]="loadingOrderList || selectedButton === '3days'"
            >
                за 3 дня
            </button>
            <button
                class="header__buttons-button"
                (click)="btnAllDays()"
                [class.selected]="selectedButton === 'all'"
                [disabled]="
                    loadingOrderList ||
                    (selectedButton === 'all' && !customDateSelected)
                "
            >
                Все
            </button>
            <button class="header__buttons-button" (click)="btnFiltrOrderUp()">
                {{ orderUPText }}
            </button>
        </div>
        <div
            class="payments-page__date-range"
            [class.highlighted]="customDateSelected"
        >
            <app-date-range
                [dtBegin]="dtBegin"
                [dtEnd]="dtEnd"
                (onChanged)="onDateRangeChanged($event)"
            ></app-date-range>
        </div>
    </div>

    <!-- Mobile Header -->
    <div class="mobile-header" *ngIf="isMobile">
        <div class="mobile-header__filters">
            <button
                class="mobile-header__filter-button"
                (click)="btnFiltrTek()"
                [class.selected]="selectedButton === 'today'"
            >
                за сегодня
            </button>
            <button
                class="mobile-header__filter-button"
                (click)="btnFiltr3Day()"
                [class.selected]="selectedButton === '3days'"
            >
                за 3 дня
            </button>
            <button
                class="mobile-header__filter-button"
                (click)="btnAllDays()"
                [class.selected]="selectedButton === 'all'"
            >
                Все
            </button>
            <button
                class="mobile-header__sort-button"
                (click)="btnFiltrOrderUp()"
            >
                {{ orderUPText }}
            </button>
        </div>
    </div>

    <div class="labs__body" [ngClass]="{ 'labs__body--mobile': isMobile }">
        <div *ngIf="loadingOrderList" class="loading">
            <loader type="page"> </loader>
        </div>

        <!-- Order list section -->
        <ng-container
            *ngIf="orderListLength > 0; then showTable; else showNotRec"
        ></ng-container>

        <ng-template #showNotRec>
            <div class="cls-not-rec">Нет заказов</div>
        </ng-template>

        <ng-template #showTable>
            <div
                class="grid-table"
                [ngClass]="{ 'grid-table--mobile': isMobile }"
            >
                <div
                    class="grid-body"
                    (scroll)="onScroll($event)"
                    [ngClass]="{ 'grid-body--mobile': isMobile }"
                >
                    <ng-container
                        *ngFor="let order of orderList; let i = index"
                    >
                        <ng-container *ngIf="isBlockYeer(i)">
                            <div colspan="2" class="cls__yeer">
                                {{ getYeer(i) }}
                            </div>
                        </ng-container>

                        <!-- Order row -->
                        <div
                            (click)="selectOrder(order)"
                            [ngClass]="
                                order === selectedOrder ? 'active-tag' : ''
                            "
                            class="grid-row"
                            [class.grid-row--mobile]="isMobile"
                        >
                            <div class="grid-row__date">
                                {{ getTekDay(order.dtSort) }} в
                                {{ getTime(order.dtSort) }}
                                <div class="grid-row__date-day">
                                    {{ getNameDay(order.dtSort) }}
                                </div>
                            </div>
                            <div class="grid-row__order">
                                Заказ {{ order.research_id }}
                            </div>
                        </div>
                    </ng-container>
                </div>
                <div
                    class="grid-table__paginationtext"
                    [ngClass]="{
                        'grid-table__paginationtext--mobile': isMobile
                    }"
                >
                    <ng-container *ngIf="loadingList">
                        <div class="css-spinner"></div>
                    </ng-container>
                    <ng-container *ngIf="!loadingList">
                        {{ "страница " + loadedPages + " из " + countOfPages }}
                    </ng-container>
                </div>
            </div>
        </ng-template>

        <app-order-details
            *ngIf="!isMobile && selectedOrder"
            class="app-order-details"
            [selectedOrder]="selectedOrder"
            (closeDetailsEvent)="clearSelectedOrder($event)"
            (openDocReseachChildModalEvent)="
                openDocReseachChildModal($event.result, $event.event)
            "
        ></app-order-details>
        <div class="overlay" *ngIf="showDetails && !isMobile"></div>
        <app-reseach-child-modal
            *ngIf="showDetails"
            class="modal-details"
            [pickedResearch]="pickedResearch"
            (close)="showDetails = false"
        ></app-reseach-child-modal>
    </div>

    <app-order-details
        *ngIf="mobileVersion && selectedOrder && isMobile"
        [class.slide-out]="isSlideOut"
        #wrapperElement
        [selectedOrder]="selectedOrder"
        (closeDetailsEvent)="clearSelectedOrder($event)"
        (openDocReseachChildModalEvent)="
            openDocReseachChildModal($event.result, $event.event)
        "
    ></app-order-details>
</div>
